/**
 * ADMIN-T009 — single source of truth for error categories named in SPEC §5.5 and §14.1.
 * Adding/removing entries here is the only way to extend the vocabulary; tests assert
 * the surface remains consistent with the spec.
 */

export const ERROR_CODES = {
  // §5.5 / §14.1 — bootstrap & route lifecycle
  bootstrap_failed: 'bootstrap_failed',
  permission_matrix_load_error: 'permission_matrix_load_error',
  dictionary_load_error: 'dictionary_load_error',
  runtime_config_load_error: 'runtime_config_load_error',
  route_denied: 'route_denied',
  chunk_load_failed: 'chunk_load_failed',
  data_priming_failed: 'data_priming_failed',

  // §11.6 — API client error families
  network_error: 'network_error',
  timeout_error: 'timeout_error',
  auth_expired: 'auth_expired',
  data_scope_violation: 'data_scope_violation',
  permission_denied: 'permission_denied',
  validation_failed: 'validation_failed',
  conflict: 'conflict',
  rate_limited: 'rate_limited',
  upstream_unavailable: 'upstream_unavailable',
  internal_error: 'internal_error',

  // §10.3 / §10.7 — long task / write actions
  export_job_failed: 'export_job_failed',
  export_job_expired: 'export_job_expired',
  idempotency_conflict: 'idempotency_conflict',

  // §9 / §12 — invariants & copy isolation
  customer_copy_violation: 'customer_copy_violation',
  internal_copy_violation: 'internal_copy_violation',
  permission_bypass_attempt: 'permission_bypass_attempt',
  storage_quota_exceeded: 'storage_quota_exceeded',

  // §11.3 / §16 — upload
  upload_part_failed: 'upload_part_failed',
  upload_resume_failed: 'upload_resume_failed',
  upload_sts_unavailable: 'upload_sts_unavailable',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === 'string' && value in ERROR_CODES;
}

export const ERROR_CODE_LIST: readonly ErrorCode[] = Object.values(ERROR_CODES);
